import React from 'react';
import { Box } from '@mui/material';

// Donut geometry: r chosen so the circumference ≈ 100, letting stroke-dasharray
// be expressed directly in percent (mockup screen 9).
const RADIUS = 15.9155;
const START_OFFSET = 25; // start arcs at 12 o'clock

/**
 * DonutStat — percentage donut with a centered value/label. `segments` is a
 * list of `{ value, color }` where value is a percentage (0–100); the uncovered
 * remainder shows the grey track. See MOBILE_PLAN.md §F(9).
 */
const DonutStat = function DonutStat({
  segments = [],
  centerValue = null,
  centerLabel = null,
  size = 120,
}) {
  let cumulative = 0;

  return (
    <Box sx={{ flex: 'none', width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 42 42">
        <circle
          cx="21"
          cy="21"
          r={RADIUS}
          fill="none"
          stroke="#eef1f6"
          strokeWidth="6"
        />
        {segments.map((segment) => {
          const dash = `${segment.value} ${100 - segment.value}`;
          const offset = START_OFFSET - cumulative;
          cumulative += segment.value;
          return (
            <circle
              key={segment.color}
              cx="21"
              cy="21"
              r={RADIUS}
              fill="none"
              stroke={segment.color}
              strokeWidth="6"
              strokeDasharray={dash}
              strokeDashoffset={offset}
              strokeLinecap="round"
            />
          );
        })}
        {centerValue != null ? (
          <text
            x="21"
            y="20"
            textAnchor="middle"
            fontSize="7"
            fontWeight="700"
            fill="#1a1a1f"
          >
            {centerValue}
          </text>
        ) : null}
        {centerLabel ? (
          <text x="21" y="26" textAnchor="middle" fontSize="3.4" fill="#94a3b8">
            {centerLabel}
          </text>
        ) : null}
      </svg>
    </Box>
  );
};

export default DonutStat;
